// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2TvMl","emails":"CreateEditClinics_emails__1O8iy","emailTagLabel":"CreateEditClinics_emailTagLabel__XSvIN"};